<template>
  <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <polygon points="0 0 16 0 16 16 0 16" />
      <polygon
        points="8 10.171 14.586 3.5863 16 5.0007 8 13 -5.8298e-5 5.0007 1.4141 3.5863"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1D1D1D'
    }
  }
};
</script>
